// VIN 10번째 자리 → 연식 매핑 (30년 주기)
// 1~9 = 2001~2009, A~Y = 2010~2030 (I,O,Q,U,Z 제외)
var VIN_YEAR_MAP = {
  '1':2001,'2':2002,'3':2003,'4':2004,'5':2005,
  '6':2006,'7':2007,'8':2008,'9':2009,
  'A':2010,'B':2011,'C':2012,'D':2013,'E':2014,'F':2015,
  'G':2016,'H':2017,'J':2018,'K':2019,'L':2020,
  'M':2021,'N':2022,'P':2023,'R':2024,'S':2025,'T':2026,
  'V':2027,'W':2028,'X':2029,'Y':2030
};

// 한국 제조사 코드 (VIN 앞 3자리)
var VIN_MAKER_MAP = {
  'KNA': '기아', 'KNB': '기아', 'KNC': '기아', 'KND': '기아',
  'KMH': '현대', 'KMF': '현대',
  'KNM': '르노코리아', 'KNE': '르노코리아',
  'KPT': '쌍용', 'KPA': '쌍용',
  'KL1': '쉐보레', 'KL8': 'GM',
};

function getYearFromVin(vin, registrationYear) {
  if (!vin || vin.length < 10) return null;
  var code = vin.charAt(9).toUpperCase();
  var baseYear = VIN_YEAR_MAP[code];
  if (!baseYear) return null;

  // 30년 주기: 현재 연도+1 이하인 가장 가까운 연도 선택
  var maxYear = (registrationYear || new Date().getFullYear()) + 1;
  var best = baseYear;
  while (best > maxYear) best -= 30;
  while (best + 30 <= maxYear) best += 30;
  return best;
}

function getMakerFromVin(vin) {
  if (!vin || vin.length < 3) return null;
  var wmi = vin.substring(0, 3).toUpperCase();
  return VIN_MAKER_MAP[wmi] || null;
}

export { getYearFromVin, getMakerFromVin, VIN_YEAR_MAP, VIN_MAKER_MAP };
export default getYearFromVin;
